const Primary = {
    /**The token represents the primary.main token */
    main: "#0070F0",
    /**The token represent the white color*/
    white: "#ffffff",
    /**The token represent the primary background color*/
    background: "#F5F9FF",
    /**The token represents 95% lighter shade of the primary.white token */
    95: "#E6F1FF",
    /**The token represents 90% lighter shade of the primary.white token */
    90: "#CCE4FF",
    /**The token represents 85% lighter shade of the primary.white token */
    85: "#B3D6FF",
    /**The token represents 80% lighter shade of the primary.white token */
    80: "#99C9FF",
    /**The token represents 75% lighter shade of the primary.white token */
    75: "#80BBFF",
    /**The token represents 70% lighter shade of the primary.white token */
    70: "#66ADFF",
    /**The token represents 65% lighter shade of the primary.white token */
    65: "#4DA0FF",
    /**The token represents 60% lighter shade of the primary.white token */
    60: "#3392FF",
    /**The token represents 55% lighter shade of the primary.white token */
    55: "#1A85FF",
    /**The token represents 50% lighter shade of the primary.white token */
    50: "#0077FF",
    /**The token represents 45% lighter shade of the primary.white token */
    45: "#006BE6",
    /**The token represents 40% lighter shade of the primary.white token */
    40: "#005FCC",
    /**The token represents 35% lighter shade of the primary.white token */
    35: "#0053B3",
    /**The token represents 30% lighter shade of the primary.white token */
    30: "#004799",
    /**The token represents 25% lighter shade of the primary.white token */
    25: "#003C80",
    /**The token represents 20% lighter shade of the primary.white token */
    20: "#003066",
    /**The token represents 15% lighter shade of the primary.white token */
    15: "#00244D",
    /**The token represents 10% lighter shade of the primary.white token */
    10: "#001833",
    /**The token represents 5% lighter shade of the primary.white token */
    5: "#000C1A",
    /**The token represents 0% lighter shade of the primary.white token */
    0: "#000000",
};

export default Primary;
